import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Grid,
  Paper,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@material-ui/core'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import useStyles from './styles.js'
import { Input } from './../Input/Input'
import { signUp, signIn } from './../../store/actions/auth/sign'

export const AuthPage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const isLoading = useSelector((state) => state.loader.isLoading)
  const [isSignUp, setIsSignUp] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  })
  const switchSignHandler = () => {
    setIsSignUp((prev) => !prev)
  }
  const handleShowPassword = () => {
    setShowPassword((prev) => !prev)
  }
  const submitHandler = (event) => {
    const { email, password } = formData
    event.preventDefault()
    isSignUp
      ? dispatch(signUp(formData, clear, setIsSignUp))
      : dispatch(signIn({ email, password }, clear))
  }
  const changeInputHandler = (event) => {
    setFormData((prev) => ({
      ...prev,
      ...{
        [event.target.name]: event.target.value,
      },
    }))
  }
  const clear = () => {
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
    })
  }
  return (
    <Fragment>
      <Grid
        className={classes.authFormContainer}
        container
        direction='row'
        justify='center'
        alignItems='center'
      >
        <Grid item xs={12}>
          <Paper className={classes.authFormPaper}>
            <Grid
              className={classes.authFormHeader}
              container
              spacing={2}
              direction='column'
              justify='center'
              alignItems='center'
            >
              <Grid item xs={12}>
                <LockOutlinedIcon
                  className={classes.authFormIcon}
                  color='primary'
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant='h5'>
                  {!isSignUp ? 'SignIn' : 'SignUp'}
                </Typography>
              </Grid>
            </Grid>
            <form onSubmit={submitHandler}>
              <Grid className={classes.authFormInputs} container spacing={1}>
                {isSignUp && (
                  <>
                    <Input
                      autoFocus
                      half
                      fullWidth
                      required
                      disabled={isLoading}
                      name='firstName'
                      type='text'
                      label='First name'
                      value={formData.firstName}
                      onChange={changeInputHandler}
                    />
                    <Input
                      half
                      fullWidth
                      disabled={isLoading}
                      name='lastName'
                      type='text'
                      label='Last name'
                      value={formData.lastName}
                      onChange={changeInputHandler}
                    />
                  </>
                )}
                <Input
                  autoFocus
                  fullWidth
                  required
                  disabled={isLoading}
                  name='email'
                  type='text'
                  label='E-mail'
                  value={formData.email}
                  onChange={changeInputHandler}
                />
                <Input
                  fullWidth
                  required
                  disabled={isLoading}
                  name='password'
                  type={!showPassword ? 'password' : 'text'}
                  label='Password'
                  value={formData.password}
                  onChange={changeInputHandler}
                  handleShowPassword={handleShowPassword}
                />

                {isSignUp && (
                  <>
                    <Input
                      fullWidth
                      required
                      disabled={isLoading}
                      name='confirmPassword'
                      type={!showPassword ? 'password' : 'text'}
                      label='Confirm password'
                      value={formData.confirmPassword}
                      onChange={changeInputHandler}
                    />
                  </>
                )}
              </Grid>
              <Grid container justify='space-between'>
                <Grid item>
                  <Box className={classes.wrapper}>
                    <Button
                      variant='contained'
                      color='primary'
                      className={classes.authFormButton}
                      type='submit'
                      disabled={isLoading}
                    >
                      {isSignUp ? 'Sign up' : 'Sign in'}
                    </Button>
                    {isLoading && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Box>
                </Grid>
                <Grid item>
                  <Button
                    onClick={switchSignHandler}
                    className={classes.authFormButton}
                    color='primary'
                    disabled={isLoading}
                    disableRipple
                  >
                    {isSignUp
                      ? 'Already have an account? Sign in'
                      : "Don't have an account? Sign up"}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>
    </Fragment>
  )
}
